/**
 * Generated by @openapi-codegen from OpenAPI query parameter style/explode metadata.
 * Do not edit manually.
 */
export type QueryParameterSerialization = {
  style?: "form" | "spaceDelimited" | "pipeDelimited" | "deepObject";
  explode?: boolean;
};

export const queryParameterSerialization: Record<
  string,
  Record<string, QueryParameterSerialization>
> = {
  "get /candidates": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /candidates/{candidateId}": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /candidates/{candidateId}/documents": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /clients": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    include: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /clients/contacts": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /clients/{clientId}": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /vacancies": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /vacancies/{vacancyId}": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /messages": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /messages/{messageId}": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /users": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /me": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "patch /me": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /migrations": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /migrations/{migrationId}": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /migrations/{migrationId}/errors": {
    select: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /migrations/{migrationId}/errors/{migrationErrorId}": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /candidates/{candidateId}/remarks": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /company": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /task-workspaces": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /task-workspaces/{taskWorkspaceId}": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /task-workspaces/{taskWorkspaceId}/tasks": {
    filter: {
      style: "deepObject",
      explode: true,
    },
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /task-workspaces/{taskWorkspaceId}/tasks/{taskId}": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /task-workspaces/{taskWorkspaceId}/tasks/{taskId}/activities": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /tags": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /bookings": {
    select: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /bookings/{bookingId}": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /saved-searches": {
    select: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /saved-searches/{savedSearchId}": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /branches": {
    select: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /branches/{branchId}": {
    select: {
      style: "form",
      explode: false,
    },
  },
  "get /forms": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /forms/{formId}": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
  },
  "get /form-requests": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /form-responses": {
    select: {
      style: "form",
      explode: false,
    },
    expand: {
      style: "form",
      explode: false,
    },
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /forms/{formId}/report": {
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
  "get /forms/{formId}/responses/export": {
    filter: {
      style: "deepObject",
      explode: true,
    },
  },
};
